import styled from 'styled-components';

import SvgIcon from '~src/shared/SvgIcon';
import { media } from '~src/styles/media-templates';

import { InfoItem } from './shared.sc';

export const IsAnonymous = styled(InfoItem)`
  color: ${({ theme }) => theme.green.a10};
  display: flex;
  margin-left: 0.2rem;
`;

export const WebModalContainer = styled.div`
  display: block;
  ${media.phone`
    display: none;
  `}
`;

export const AnonText = styled.span<{ $anon: boolean; $selection: string | null }>`
  align-self: center;
  color: ${({ $anon, theme, $selection }) =>
    $selection ? theme.white.a5 : $anon ? theme.green.a10 : theme.lightBlue.a10};
  font-weight: 200;
`;

export const AnonInfoText = styled.div`
  ${media.phone`
    font-size: 15px;
    line-height: 26px;
  `}
`;

export const AnonContainer = styled(SvgIcon)<{ $anon: boolean }>`
  color: ${({ anon, theme }) => (anon ? theme.green.a10 : theme.lightBlue.a10)};
  margin-left: 5px;
`;
